import {
  View,
  Text,
  ActivityIndicator,
  TextInput,
  Linking
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { useEffect } from 'react'
import { useStoreStore } from '../../../stores/storeInfo'
import ScreenStatus from '../../home/ScreenStatus'


const PainformationForm = ({ navigation, route }) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values
    } = params

    const { loading, postpaonline, getmodetails, getpapsdcodes, papsdcode, psdloading, error } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()
    const {
        storeData: storeData,
        error: errorStore,
        loading: storeLoading,
        fetchData,
        updateData
    } = useStoreStore()

    const hometotal =
        Number(papsdcode?.homeSchoolResidentEit?.replace(/[^0-9.-]+/g, "")) +
        Number(papsdcode?.homeResidentEit?.replace(/[^0-9.-]+/g, ""));

    const intialValues = {
        municipality: values?.municipality ? values?.municipality : papsdcode?.homeLocation,
        county: values?.county ? values?.county : papsdcode?.homeCounty,
        residentpsdcode: values?.residentpsdcode ? values?.residentpsdcode : papsdcode?.homePsdCode,
        totalresidenteitrate: values?.totalresidenteitrate ? values?.totalresidenteitrate : hometotal
    }

    const paschema = yup.object({
        municipality: yup.string().required('Municipality is a required field'),
        county: yup.string().required('County is a required field'),
        residentpsdcode: yup
            .string()
            .required('Resident PSD code is a required field'),
        totalresidenteitrate: yup
            .string()
            .required('Total resident EIT rate is a required field')
    })
    useEffect(() => {
        getmodetails(initializestore?.initializeData?.userkey)
        fetchData(userId)
        getpapsdcodes(initializestore?.initializeData?.userkey)
    }, [])


    if (storeLoading || psdloading) return <ActivityIndicator />

    if (error || errorStore) return <ScreenStatus message={error || errorStore} />

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'PA Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    enableReinitialize
                    initialValues={{ ...intialValues }}
                    validationSchema={paschema}
                    onSubmit={async (values, actions) => {
                        const data = {
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            essObKey: essUserOnBoardingKey,
                            completeOnline: mode === 'upload' ? false : true,
                            essUserKey: initializestore.initializeData.userkey,
                            entityId: personalstore.personalData?.entityId,
                            municipality: values?.municipality,
                            county: values?.county,
                            residentPsdcode: Number(values?.residentpsdcode),
                            totalResdientEitrate: Number(values?.totalresidenteitrate),
                            WorkLocationPsdcode: papsdcode?.workPsdCode,
                            WorkCounty: papsdcode?.workCounty,
                            WorkMunicipality: papsdcode?.workLocation,
                            totalNonResdientEitrate: Number(papsdcode?.workNonResidentEit.replace(/[^0-9.-]+/g, ""))
                        }

                        const response = await postpaonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('painformationTable', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }

                    }
                    }
                >
                    {(props) => (
                        <>
                            <Card>

                                <View style={{ marginBottom: 10 }}>
                                    <Text style={[globalStyles.inputLabelPrimary]}>
                                        Please visit <Text style={{ fontWeight: 'bold', textDecorationLine: 'underline' }} onPress={() => Linking.openURL('https://apps.dced.pa.gov/Munstats-Public/FindLocalTax.aspx')}>https://apps.dced.pa.gov/Munstats-Public/FindLocalTax.aspx </Text> to obtain the correct Resident PSD Code and Total Resident EIT Rate to enter. You will also need the address of your home store.  For your convenience, it is listed below:
                                    </Text>
                                    <View style={{ alignItems: 'center', marginTop: 8 }}>
                                        <Text>{storeData?.storeName}</Text>
                                        <Text>
                                            {storeData?.storeAddress1} {storeData?.storeAddress2}
                                        </Text>
                                        <Text>{storeData?.storeAddress3}</Text>
                                    </View>


                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter Municipality  *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '38%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.municipality}
                                            onChangeText={(text) => {
                                                props.handleChange('municipality')(text)
                                            }}
                                        />
                                        {props.touched.municipality &&
                                            props.errors.municipality && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.municipality as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter County * '}
                                        </Text>
                                    </View>
                                    <View style={{ width: '38%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.county}
                                            onChangeText={(text) => {
                                                props.handleChange('county')(text)
                                            }}
                                        />
                                        {props.touched.county && props.errors.county && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.county as string}
                                            </Text>
                                        )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter RESIDENT PSD CODE *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '38%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight, globalStyles.inputReadOnly]}
                                            value={props.values.residentpsdcode}
                                            keyboardType="numeric"

                                        />
                                        {props.touched.residentpsdcode &&
                                            props.errors.residentpsdcode && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.residentpsdcode as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter TOTAL RESIDENT EIT RATE * '}
                                        </Text>
                                    </View>
                                    <View style={{ width: '38%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={String(props.values.totalresidenteitrate)}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d*\.?\d*$/.test(text)) {
                                                    props.handleChange('totalresidenteitrate')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.totalresidenteitrate &&
                                            props.errors.totalresidenteitrate && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.totalresidenteitrate as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default PainformationForm


